module.exports = __webpack_public_path__ + "static/media/pelican.afce9737.svg";